import React from "react";
import { Bar } from "react-chartjs-2";
import { STATUS_OPTION, STEP_OPTION, statusOptions } from "../../../components/buckets/constants";
import { dataForDayTemplate } from "../chartTemplates";

export function DayStatus({filteredBuckets}){

    const options =  {
        scales: {
            y: {
            beginAtZero: true
            }
        }
    }
      
      function calculateColorTotal(filteredBuckets2){
         
        let colorTotals = filteredBuckets2.reduce((acc,v,i,arr)=>{
            acc[v.actionStatus] = acc[v.actionStatus] + Number(v.points)
            return acc
          }
          ,
          {
            black:0,
            purple:0,
            red:0,
            white:0,
            yellow:0,
            green:0,
            blue:0
          })
          return colorTotals
        }
    let dataObjectForDay = calculateColorTotal(filteredBuckets)
    let dataArrayForDay1 = statusOptions.map(color => dataObjectForDay[color])
  



    return <Bar
              type="bar"
              options={options}
              data={dataForDayTemplate(dataArrayForDay1, statusOptions,statusOptions,"Day Action Points by Color")}
              />
}